import { ReplicatedAction } from "../../../core/game/interfaces/ReplicatedAction";
import { StartGameActionEffect, StartGameActionValidator } from "../../../core/game/interfaces/StartGameAction";
function Contact3DStartGameEffect(data, context) {
    StartGameActionEffect(data, context);
    context.gameState.commitNewSecretWordGiver();
}
export const Contact3DStartGame = new ReplicatedAction('Contact3DStartGame', StartGameActionValidator, Contact3DStartGameEffect);
//# sourceMappingURL=Contact3DStartGame.js.map